var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.posterUrl)?_c('PresentationPoster',_vm._b({},'PresentationPoster',{ posterUrl: _vm.posterUrl, isPresenter: _vm.isPresenter },false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }